/**
 * Amazon ASIN helpers shared between the backend and frontend apps so the
 * validation rule stays in lockstep across the codebase.
 */

/**
 * ASINs are ten characters, either:
 * - a "B" followed by nine alphanumerics (all non-book products)
 * - an ISBN-10 for books: nine digits followed by a digit or "X" check character
 */
export const AMAZON_ASIN_REGEX = /^(B[a-zA-Z0-9]{9}|\d{9}[\dXx])$/;

/** Returns true when `input` is a valid Amazon ASIN. */
export const isValidAmazonAsin = (input: string): boolean =>
  typeof input === "string" && AMAZON_ASIN_REGEX.test(input);

/**
 * Trims and uppercases an ASIN. Amazon and Keepa return ASINs uppercased, so
 * normalize before sending them or matching results back up.
 */
export const normalizeAsin = (
  asin: string | null | undefined
): string | undefined => asin?.trim().toUpperCase();
